import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import zh from "./locales/zh.json";
import ja from "./locales/ja.json";
import ru from "./locales/ru.json";

const CLICTOEAT_LANGS = [
  "en",
  "fr",
  "de",
  "es",
  "it",
  "pt",
  "ar",
  "zh",
  "ja",
  "ru",
];

const LANG_MANUAL_KEY = "currentLanguageManual";

function detectBrowserLanguage(fallback = "en") {
  if (typeof navigator === "undefined") return fallback;
  const prefs = [
    ...(navigator.languages || []),
    navigator.language,
  ].filter(Boolean);
  try {
    prefs.push(Intl.DateTimeFormat().resolvedOptions().locale);
  } catch {
    /* ignore */
  }
  for (const pref of prefs) {
    const code = String(pref)
      .replace("_", "-")
      .split("-")[0]
      .toLowerCase();
    if (CLICTOEAT_LANGS.includes(code)) return code;
  }
  return fallback;
}

function resolveInitialLanguage() {
  try {
    const manual = localStorage.getItem(LANG_MANUAL_KEY) === "1";
    const saved = localStorage.getItem("currentLanguage");
    const code = saved ? String(saved).split("-")[0].toLowerCase() : "";
    if (manual && code && CLICTOEAT_LANGS.includes(code)) return code;
  } catch {
    /* ignore */
  }
  return detectBrowserLanguage();
}

export function persistChosenLanguage(lng) {
  const code = String(lng || "en").split("-")[0].toLowerCase();
  const next = CLICTOEAT_LANGS.includes(code) ? code : "en";
  localStorage.setItem("currentLanguage", next);
  localStorage.setItem(LANG_MANUAL_KEY, "1");
}

const savedLanguage = resolveInitialLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    es: { translation: es },
    pt: { translation: pt },
    ar: { translation: ar },
    de: { translation: de },
    it: { translation: it },
    zh: { translation: zh },
    ja: { translation: ja },
    ru: { translation: ru },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
